<app-side-menu>
  <div class="b2b-ops-page claim-form-page">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div>
          <button type="button" class="btn-back" (click)="navigateBack()"><i class="fas fa-arrow-left"></i></button>
          <h1 class="page-title"><i class="fas fa-car-crash me-2"></i>{{ pageTitle }}</h1>
          <p class="page-subtitle" *ngIf="contractNumber">Contrato: {{ contractNumber }} — {{ contractName }}</p>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          <button type="button" class="btn btn-light" (click)="navigateBack()" [disabled]="submitting">
            {{ viewMode ? 'Voltar' : 'Cancelar' }}
          </button>
          <button *ngIf="viewMode && claimId" type="button" class="btn btn-outline-light" (click)="printClaim()">
            <i class="fas fa-print me-1"></i> Imprimir
          </button>
          <button *ngIf="!viewMode" type="button" class="btn btn-success" (click)="submit()" [disabled]="submitting || uploading || isLoading">
            <i class="fas fa-spinner fa-spin me-1" *ngIf="submitting || uploading"></i>
            {{ claimId ? 'Salvar' : 'Criar' }}
          </button>
        </div>
      </div>
    </div>

    <app-loading [show]="isLoading" message="Carregando sinistro..."></app-loading>

    <div class="b2b-ops-card" *ngIf="!isLoading">
      <ul class="nav nav-tabs claim-detail-tabs mb-3" *ngIf="showCommentTab">
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="detailTab === 'dados'" (click)="selectTab('dados')">
            <i class="fas fa-file-alt me-1"></i> Dados / Orçamentos e anexos
          </button>
        </li>
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="detailTab === 'comentarios'" (click)="selectTab('comentarios')">
            <i class="fas fa-comments me-1"></i> Comentários
          </button>
        </li>
      </ul>

      <app-collaboration-comments
        *ngIf="showCommentTab && detailTab === 'comentarios'"
        entityType="Claim"
        [entityId]="claimId"
        [contractId]="contractId"
        [allowInternal]="true"
        emptyLabel="Nenhum comentário neste sinistro.">
      </app-collaboration-comments>

      <form [formGroup]="form" class="claim-form" (ngSubmit)="submit()" *ngIf="!showCommentTab || detailTab === 'dados'">
        <section class="form-section">
          <h2 class="section-title">Dados do sinistro</h2>
          <div class="b2b-ops-form-grid">
            <div class="form-group">
              <app-b2b-contract-plate-select
                [contractId]="contractId"
                formControlName="plate"
                (plateSelected)="onPlateSelected($event)">
              </app-b2b-contract-plate-select>
            </div>
            <div class="form-group">
              <label class="form-label">Condutor</label>
              <input type="text" class="form-control" formControlName="driverName">
            </div>
            <div class="form-group">
              <label class="form-label">Data</label>
              <input type="date" class="form-control" formControlName="claimDate">
            </div>
            <div class="form-group">
              <label class="form-label">UF</label>
              <input type="text" class="form-control" formControlName="state" maxlength="2" placeholder="SP">
            </div>
            <div class="form-group">
              <label class="form-label">Status</label>
              <select class="form-select" formControlName="status">
                <option *ngFor="let s of statusOptions" [value]="s.value">{{ s.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Local (agenda)</label>
              <input type="text" class="form-control" formControlName="agendaLocation" placeholder="Oficina / pátio">
            </div>
            <div class="form-group full">
              <label class="form-label">Endereço (agenda)</label>
              <input type="text" class="form-control" formControlName="agendaAddress">
            </div>
            <div class="form-group full">
              <label class="form-label">Descrição</label>
              <textarea class="form-control" rows="3" formControlName="description"></textarea>
            </div>
            <div class="form-group full">
              <label class="form-label">Observações</label>
              <textarea class="form-control" rows="3" formControlName="notes"></textarea>
            </div>
          </div>
        </section>

        <section class="form-section">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h2 class="section-title mb-0">Orçamentos (máx. 3)</h2>
            <button *ngIf="canEditBudgets" type="button" class="btn btn-sm btn-outline-primary"
              (click)="addBudget()" [disabled]="budgets.length >= 3">
              <i class="fas fa-plus me-1"></i> Adicionar
            </button>
          </div>
          <p class="text-muted small" *ngIf="budgets.length === 0">Nenhum orçamento. CNPJ livre — sem cadastro em Prestadores.</p>
          <div class="budget-card" *ngFor="let b of budgets; let i = index">
            <div class="budget-card-head">
              <strong>Orçamento {{ i + 1 }}</strong>
              <span class="badge bg-success" *ngIf="b.isWinner">Vencedor</span>
              <button *ngIf="canEditBudgets" type="button" class="btn btn-sm btn-link text-danger" (click)="removeBudget(i)">Remover</button>
            </div>
            <div class="budget-grid">
              <div>
                <label class="form-label">Oficina</label>
                <input class="form-control" [(ngModel)]="b.workshopName" [ngModelOptions]="{standalone: true}" [disabled]="!canEditBudgets">
              </div>
              <div>
                <label class="form-label">CNPJ/CPF</label>
                <input class="form-control" [(ngModel)]="b.workshopDocument" [ngModelOptions]="{standalone: true}" [disabled]="!canEditBudgets">
              </div>
              <div>
                <label class="form-label">Valor</label>
                <input type="number" step="0.01" class="form-control" [(ngModel)]="b.amount" [ngModelOptions]="{standalone: true}" [disabled]="!canEditBudgets">
              </div>
              <div class="full">
                <label class="form-label">Notas</label>
                <textarea class="form-control" rows="2" [(ngModel)]="b.notes" [ngModelOptions]="{standalone: true}" [disabled]="!canEditBudgets"></textarea>
              </div>
              <div class="full">
                <label class="form-label">Anexos do orçamento</label>
                <div class="attach-gallery" *ngIf="b.attachments?.length">
                  <figure class="attach-card" *ngFor="let a of b.attachments">
                    <a *ngIf="isImageAttachment(a); else budgetDoc" [href]="a.blobUrl" target="_blank" rel="noopener">
                      <img [src]="a.blobUrl" [alt]="a.fileName || 'anexo'" loading="lazy" />
                    </a>
                    <ng-template #budgetDoc>
                      <a class="attach-doc" [href]="a.blobUrl" target="_blank" rel="noopener">
                        <i class="fas fa-file"></i>
                        <span>{{ a.fileName || a.blobUrl }}</span>
                      </a>
                    </ng-template>
                    <figcaption>
                      <span class="attach-name" [title]="a.fileName || a.blobUrl">{{ a.fileName || 'Arquivo' }}</span>
                      <button *ngIf="canEditBudgets" type="button" class="btn btn-link btn-sm text-danger p-0"
                        (click)="removeBudgetAttachment(i, a)">Remover</button>
                    </figcaption>
                  </figure>
                </div>
                <div class="attach-gallery" *ngIf="b.pendingFiles?.length">
                  <figure class="attach-card" *ngFor="let f of b.pendingFiles; let fi = index">
                    <ng-container *ngIf="isImageAttachment(f); else pendingBudgetDoc">
                      <img [src]="pendingFilePreviewUrl(f)" [alt]="f.name" loading="lazy" />
                    </ng-container>
                    <ng-template #pendingBudgetDoc>
                      <div class="attach-doc">
                        <i class="fas fa-file"></i>
                        <span>{{ f.name }} (pendente)</span>
                      </div>
                    </ng-template>
                    <figcaption>
                      <span class="attach-name" [title]="f.name">{{ f.name }} (pendente)</span>
                      <button *ngIf="canEditBudgets" type="button" class="btn btn-link btn-sm text-danger p-0"
                        (click)="removePendingBudgetFile(i, fi)">Remover</button>
                    </figcaption>
                  </figure>
                </div>
                <input *ngIf="canEditBudgets" type="file" multiple accept=".pdf,.png,.jpg,.jpeg,.webp,.docx"
                  (change)="onBudgetFilesSelected(i, $event)">
              </div>
            </div>
          </div>
        </section>

        <section class="form-section">
          <h2 class="section-title">Anexos do sinistro (avarias)</h2>
          <div class="attach-gallery" *ngIf="claimAttachments.length">
            <figure class="attach-card" *ngFor="let a of claimAttachments">
              <a *ngIf="isImageAttachment(a); else claimDoc" [href]="a.blobUrl" target="_blank" rel="noopener">
                <img [src]="a.blobUrl" [alt]="a.fileName || 'anexo'" loading="lazy" />
              </a>
              <ng-template #claimDoc>
                <a class="attach-doc" [href]="a.blobUrl" target="_blank" rel="noopener">
                  <i class="fas fa-file"></i>
                  <span>{{ a.fileName || a.blobUrl }}</span>
                </a>
              </ng-template>
              <figcaption>
                <span class="attach-name" [title]="a.fileName || a.blobUrl">{{ a.fileName || 'Arquivo' }}</span>
                <button *ngIf="!viewMode" type="button" class="btn btn-link btn-sm text-danger p-0"
                  (click)="removeClaimAttachment(a)">Remover</button>
              </figcaption>
            </figure>
          </div>
          <div class="attach-gallery" *ngIf="pendingClaimFiles.length">
            <figure class="attach-card" *ngFor="let f of pendingClaimFiles; let i = index">
              <ng-container *ngIf="isImageAttachment(f); else pendingClaimDoc">
                <img [src]="pendingFilePreviewUrl(f)" [alt]="f.name" loading="lazy" />
              </ng-container>
              <ng-template #pendingClaimDoc>
                <div class="attach-doc">
                  <i class="fas fa-file"></i>
                  <span>{{ f.name }} (pendente)</span>
                </div>
              </ng-template>
              <figcaption>
                <span class="attach-name" [title]="f.name">{{ f.name }} (pendente)</span>
                <button *ngIf="!viewMode" type="button" class="btn btn-link btn-sm text-danger p-0"
                  (click)="removePendingClaimFile(i)">Remover</button>
              </figcaption>
            </figure>
          </div>
          <input *ngIf="!viewMode" type="file" multiple accept=".pdf,.png,.jpg,.jpeg,.webp,.docx"
            (change)="onClaimFilesSelected($event)">
        </section>

        <div class="form-actions d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-secondary" (click)="navigateBack()" [disabled]="submitting">
            {{ viewMode ? 'Voltar' : 'Cancelar' }}
          </button>
          <button *ngIf="viewMode && claimId" type="button" class="btn btn-outline-secondary" (click)="printClaim()">
            <i class="fas fa-print me-1"></i> Imprimir
          </button>
          <button *ngIf="!viewMode" type="submit" class="btn btn-primary" [disabled]="submitting || uploading">
            <i class="fas fa-spinner fa-spin me-1" *ngIf="submitting || uploading"></i>
            {{ claimId ? 'Salvar' : 'Criar' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</app-side-menu>
